import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const KeyFactorsIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M8.88184 17C4.46356 17 0.881836 13.4183 0.881836 9C0.881836 4.58172 4.46356 1 8.88184 1"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <path
        d="M8.88118 14.3385C5.93567 14.3385 3.54785 11.9507 3.54785 9.00521C3.54785 6.05969 5.93567 3.67188 8.88118 3.67188"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <path
        d="M8.88184 11.3379C7.50112 11.3379 6.38184 10.2186 6.38184 8.83789C6.38184 7.45718 7.50112 6.33789 8.88184 6.33789"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </g>
  );
};

export const KeyFactorsIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <KeyFactorsIconGroup {...props} />
    </svg>
  );
};
